<template>
    <b-tabs
        horizontal
        :value="value"
        :showBackground="showBackground"
        @activate-tab="handleActivateTab"
        @changed="handleChanged"
        @input="$emit('input', $event)"
        v-bind="$props"
    >
        <template v-if="$slots['tabs-start']" #tabs-start>
            <slot name="tabs-start" />
        </template>

        <template v-if="$slots['tabs-end']" #tabs-end>
            <slot name="tabs-end" />
        </template>

        <template v-if="$slots['empty']" #empty>
            <slot name="empty" />
        </template>

        <slot />
    </b-tabs>
</template>

<script>
import { BTabs } from 'bootstrap-vue'

export default {
    components: { BTabs },
    props: {
        value: { type: Number, default: null },
        showBackground: { type: Boolean, default: false },
        vertical: { type: Boolean, default: false },
        tabRefs: { type: Array }
    },
    data: () => ({
        validTabIndex: null,
    }),
    methods: {
        handleActivateTab(newTabIndex, prevTabIndex, bvEvent) {

            if (!Array.isArray(this.tabRefs)) {

                this.$emit('activate-tab', newTabIndex, prevTabIndex, bvEvent)

                return
            }

            if (newTabIndex === this.validTabIndex) {

                this.validTabIndex = null

                return
            }

            bvEvent.preventDefault()

            this.tabRefs[prevTabIndex].validate()
                .then(valid => {

                    if (valid) {

                        this.validTabIndex = newTabIndex

                        this.$emit('input', newTabIndex)
                    }
                    else {

                        this.$emit('input', prevTabIndex)
                    }
                })
        },
        handleChanged(currentTabs, previousTabs) {

            this.$emit('changed', currentTabs, previousTabs)
        }
    }
}
</script>

<style scoped>
.tabs:not([showBackground]) >>> .nav-tabs {
    background: rgb(255 255 255);
}

[showBackground] >>> .nav-tabs {
    background: rgb(245 245 245);
}
</style>